<button
  mat-raised-button
  color="primary"
  type="button"
  (click)="uploader.click()"
>
  <mat-icon>add</mat-icon>
  {{ "PRODUCTS.IMPORT.UPLOAD_TABLE.BTN.TITLE" | translate }}
</button>

<div>
  <div *ngIf="(isTablesSaving$ | async) === true" class="spinner-container">
    <mat-spinner
      color="primary"
      diameter="24"
      mode="indeterminate"
    ></mat-spinner>
  </div>

  <div *ngIf="(isTablesSaving$ | async) === false">{{ lastSavedImages }}</div>
</div>

<ng-container
  *ngIf="(isTablesSaving$ | async) === false && lastSavedImages.length > 0"
>
  <button
    mat-raised-button
    color="primary"
    type="button"
    (click)="validateTables()"
  >
    {{ "PRODUCTS.IMPORT.VALIDATE_TABLE.BTN.TITLE" | translate }}
  </button>
  <div *ngIf="!!(isTablesValidating$ | async)" class="spinner-container">
    <mat-spinner
      color="primary"
      diameter="24"
      mode="indeterminate"
    ></mat-spinner>
  </div>
  <ng-container
    *ngIf="
      validateClicked &&
      (isTablesValidating$ | async) === false &&
      productImportTableTableSource.data.length > 0
    "
  >
    <div>{{ "PRODUCTS.IMPORT.TABLE_CHECKER.INVALID" | translate }}</div>
    <app-list-table
      [isLoading]="!!(isTablesValidating$ | async)"
      [columns]="displayedColumns"
      [dataSource]="productImportTableTableSource"
      [pageable]="false"
      [customCellValue]="getCellValue"
    >
    </app-list-table>
  </ng-container>
  <ng-container
    *ngIf="
      validateClicked &&
      (isTablesValidating$ | async) === false &&
      productImportTableTableSource.data.length === 0
    "
  >
    <div>{{ "PRODUCTS.IMPORT.TABLE_CHECKER.VALID" | translate }}</div>
  </ng-container>
</ng-container>

<form [formGroup]="uploadTableForm" style="display: none">
  <input
    formControlName="file"
    id="upload_import_table_file"
    type="file"
    multiple
    class="form-control"
    [accept]="acceptedTypes"
    #uploader
    (change)="onFileChange($event)"
  />
</form>
